var environment = {
  getEnv: function () {
    var env = '';
    switch (process.env.CROSS_ENV) {
      case 'dev':
      case 'development':
        env = 'dev-';
        break;
      case 'test':
        env = 't-';
        break;
      case 'prepare':
        env = 'pre-';
        break;
      default:
        env = '';
        break;
    }
    return env;
  },
  getApiEnv: function () {
    var apiEnv = this.getEnv();
    if (apiEnv === 'dev-' && process.env.CROSS_ENV !== 'development') {
      apiEnv = 't-';
    }
    return apiEnv;
  },
  getApigateWay: function () {
    var apiEnv = this.getApiEnv();
    var url = "https://" + apiEnv + "apigateway.gaodun.com";
    return url;
  }
};
export default environment;